"use strict";

var _regeneratorRuntime = require("/codebuild/output/src013157826/src/gardner/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator = require("/codebuild/output/src013157826/src/gardner/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currentUserHasValidSubscription = exports.hasValidSubscription = exports.getSubscriptionAttribute = void 0;

var aws_amplify_1 = require("aws-amplify");

var StripeAttributes = {
  subscriptionEnd: "custom:StripeSubEnd"
};

var getUserAttributes = function getUserAttributes(user) {
  return new Promise(function (resolve, reject) {
    user.getUserAttributes(function (err, data) {
      if (err !== null) reject(err);else resolve(data);
    });
  });
};

function getSubscriptionAttribute(_x) {
  return _getSubscriptionAttribute.apply(this, arguments);
}

function _getSubscriptionAttribute() {
  _getSubscriptionAttribute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(user) {
    var attrs;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getUserAttributes(user);

          case 2:
            attrs = _context3.sent;
            return _context3.abrupt("return", attrs === null || attrs === void 0 ? void 0 : attrs.find(function (it) {
              return it.getName() === StripeAttributes.subscriptionEnd;
            }));

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getSubscriptionAttribute.apply(this, arguments);
}

exports.getSubscriptionAttribute = getSubscriptionAttribute;

var hasValidSubscription = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(user) {
    var endDate;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getSubscriptionAttribute(user);

          case 2:
            endDate = _context.sent;

            if (endDate) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", false);

          case 5:
            return _context.abrupt("return", new Date(endDate.getValue()) > new Date());

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function hasValidSubscription(_x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.hasValidSubscription = hasValidSubscription;

var currentUserHasValidSubscription = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var user;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return aws_amplify_1.Auth.currentAuthenticatedUser();

          case 2:
            user = _context2.sent;
            return _context2.abrupt("return", exports.hasValidSubscription(user));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function currentUserHasValidSubscription() {
    return _ref2.apply(this, arguments);
  };
}();

exports.currentUserHasValidSubscription = currentUserHasValidSubscription;